import React, { Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,    
    Snackbar
} from '@material-ui/core';

import classNames from 'classnames';
import themeService from '../themes/themeService';
import TextField from  '../components/shared/ppbn-textfield';
import emailValidator from '../components/shared/emailValidator';
import { LoginService } from 'common';
import NewPasswordSection from '../components/NewPasswordSection';
import UserStorage from '../utility/UserStorage';
import ForgotPasswordForm from './ForgotPasswordForm';
import WebHttpService from '../services/WebHttpService'
import clientConfig from '../clientConfig'

const { palette } = themeService.getTheme();

const loginService = new LoginService(WebHttpService, UserStorage,clientConfig)

const styles = {
    form: {
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center',
        paddingTop: '5rem',
    },
    container: {
        background: `${palette.common.gray}`,
        border: `1px solid ${palette.primary.dark}`,
        padding: '4rem',
        paddingBottom : '2rem',
        borderRadius: '3px',
        display: 'flex',
        flexDirection: 'column',
        width: '450px',        
        alignContent: 'center'
    },
    underlineBtn: {
        marginTop: '2.5rem',
        textDecoration: 'underline'
    },
    textField: {
        paddingBottom: '.75rem',        
    },
    validatePasswordField : {        
        minHeight: '120px'        
    },
    changePasswordBtn: {
        marginTop: '2.5rem',
    }

}

export class LoginPage extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
            username:'',
            password:'',
            alertOpen: false,
            newPassword:'',
            confirmNewPassword:'',
            alertText:'',
            newPasswordRequired:false,
            firstname:'',            
            resetPassword : false,
            status: {
                open: false,                
            }
        };
    }

    componentDidMount() {
        this.props.setIsAuthenticated(false);
    }

    handleOpenWithText = (text) => {
        this.setState({ alertOpen: true, alertText : text });
    };

    handleClose = () => {
        this.setState({ alertOpen: false, password:'' });
    };

    requireNewPassword() {
        if (this.state.newPasswordRequired) {
            return <NewPasswordSection newPassword={this.state.newPassword} className='new-password-section' onChange={(newState) => this.setState(newState)}/>
        }
    }

    onForgotPasswordClick() {        
        if(emailValidator.isValid(this.state.username)) {
            loginService.forgotPassword(this.state.username, ({success}) => {
                if(success) {
                    this.setState({resetPassword : true});
                } else {
                    this.setState({ alertOpen : true, alertText : "A user with that email does not exist."});       
                }
            });
        } else {
             this.setState({ alertOpen : true, alertText : "Please enter a username to start the password reset."});
        }        
    }

    loginForm(classes) {
        return (
            <form className={classes.form} onSubmit={(event) => this.handleClick(event)}>
                <div className={classNames(classes.container, 'form-container')}>
                    <TextField
                        className={classNames(classes.textField, 'username')}
                        tabIndex={0}
                        label="Username"
                        value={this.state.username}
                        onChange={(e) => {
                            this.setState({ username: e.target.value });
                        }} />
                    <br />
                    <TextField
                        className={classNames(classes.textField, 'password')}
                        type="password"
                        label="Password"
                        value={this.state.password}
                        onChange={(e) => this.setState({ password: e.target.value })} />
                    <br />
                    {this.requireNewPassword()}
                    <br />
                    <Button
                        variant='contained'
                        className='login-submit'
                        type="submit"
                        color='primary'>Login
                    </Button>
                    <Button size='small' 
                            id='forgot-password-btn' 
                            className={classes.underlineBtn} onClick={() => { this.onForgotPasswordClick() }}>
                            Forgot Password?
                    </Button>                    
                </div>
            </form>
        )
    }

    updateStatus(status) {
        if(status) {
            this.setState({ resetPassword : false, status});
        } else {
            this.setState({ resetPassword : false});
        }
    }

    render() {
        const { classes } = this.props;
        const { status } = this.state;
        return (
            <div>
                {this.state.resetPassword ? 
                    <ForgotPasswordForm 
                        done={ (status) => {this.updateStatus(status)}} 
                        alert={(alertText) => this.setState({ alertOpen : true, alertText } )}                         
                        username={this.state.username}/> : this.loginForm(classes) }
                <Dialog
                        id="login-failure-dialog"
                        open={this.state.alertOpen}
                        onClose={this.handleClose}>
                        <DialogContent>
                            <DialogContentText id='login-failure-text'>
                                {this.state.alertText}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button id="failure-button" onClick={this.handleClose} variant="text" color="primary">
                                Ok
                        </Button>
                        </DialogActions>
                </Dialog>
                <Snackbar
                    open={status.open}
                    message={status.message}
                    variant={status.variant}
                    autoHideDuration={3000}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center',}}
                    onClose={() => this.setState({ status: { open: false } })}
                />
            </div>
        );
    }

    validateNewPasswords() {     
        if(this.state.newPassword && 
            this.state.confirmNewPassword && 
            this.state.newPassword.length > 0 && 
            this.state.confirmNewPassword.length > 0 && 
            this.state.newPassword === this.state.confirmNewPassword) {
            return false;
        } else { 
            return true; 
        }
    }

    handleClick(event) {        
        const pathname  = this.props.location.state && this.props.location.state.from.pathname;        
        event.stopPropagation();
        event.preventDefault();
        if(this.state.newPasswordRequired && this.validateNewPasswords()) {            
            this.handleOpenWithText('New password and password confirmation must be equal');
        } else {            
            let newPassword = this.state.newPasswordRequired ? this.state.newPassword : null;
            let firstName = this.state.newPasswordRequired ? this.state.firstname : null;
            loginService.login(this.state.username, this.state.password, newPassword, firstName, false).then( (response) => {
                if(response.success) {
                    this.props.setIsAuthenticated(true);                    
                    if (pathname === "/app") {
                        this.props.history.replace({pathname});
                    } else {
                        this.props.history.replace({pathname:'/dashboard'});
                    }
                } else {
                    if(response.newPasswordRequired) {                 
                        this.setState({newPasswordRequired:true});
                    }
                    else if(response.companyAccessDenied) {                        
                        this.handleOpenWithText(response.message)                    
                    } else {
                        // Get failure back from the backend concerning access
                        this.handleOpenWithText('Failed to login with provided username and password');
                    }
                }
            });
        }
    }
}

export default withStyles(styles)(LoginPage);